import React from 'react';
import { Select, Form } from 'antd';
// import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
// const Option = Select.Option;
const VehicleOwner = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Собственник ТС">
      {getFieldDecorator('vehicleOwner')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите собственника ТС"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        ></Select>
      )}
    </Form.Item>
  );
};

export default VehicleOwner;
